import styled from 'styled-components'

const Wrapper = styled.section`
    .header{
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  .header h5{
    text-transform: none;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .header .btn{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 0.5rem;
    box-shadow: var(--shadow-2);
    text-transform: none;
  }

  .diagramsContainer{
    display: grid;
    grid-template-columns: auto;
    grid-row-gap: 30px;
    @media (min-width: 576px) {
    }
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
    }
    @media (min-width: 1120px) {
      grid-template-columns: auto auto;
    }
  }

  .diagramAndHeading{
    text-align: center;
  }

  .diagram{
    height: 300px;
    width: 100%;
    @media (min-width: 576px) {
    }
    @media (min-width: 768px) {
    }
    @media (min-width: 992px) {
    }
    @media (min-width: 1120px) {
    }
  }
`

export default Wrapper